module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70305/img/content-remix-post-publish/content-remix-pt.png"